import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'Home',
  redirect: '/home',
  component: () => import( /* webpackChunkName: "home" */ '../views/home/index.vue'),
  children: [{
    path: '/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "home" */ '../views/home/home.vue'),
  },
  {
    path: '/classCourse',
    name: 'classCourse',
    redirect: '/classCourse/chapters',
    component: () => import( /* webpackChunkName: "classCourse" */ '../views/classCourse/index.vue'),
    children: [
      {
        path: '/classCourse/chapters',
        name: 'chapters',
        component: () => import( /* webpackChunkName: "chapters" */ '../views/classCourse/chapters.vue'),
      },
      {
        path: '/classCourse/teams',
        name: 'teams',
        component: () => import( /* webpackChunkName: "teams" */ '../views/classCourse/teams.vue'),
      },
      {
        path: '/classCourse/teams/teamOperate',
        name: 'teamOperate',
        component: () => import( /* webpackChunkName: "teamOperate" */ '../views/classCourse/teamOperate/index.vue'),
      },
      {
        path: '/classCourse/students',
        name: 'students',
        component: () => import( /* webpackChunkName: "students" */ '../views/classCourse/students.vue'),
      },
      {
        path: '/classCourse/rank',
        name: 'rank',
        component: () => import( /* webpackChunkName: "rank" */ '../views/classCourse/rank.vue'),
      },
      {
        path: '/classCourse/platformaccount',
        name: 'platformAccount',
        component: () => import( /* webpackChunkName: "platformAccount" */ '../views/classCourse/platformAccount.vue'),
      },
      {
        path: '/classCourse/works',
        name: 'works',
        component: () => import( /* webpackChunkName: "works" */ '../views/classCourse/works.vue'),
      },
      {
        path: '/classCourse/exam',
        name: 'exam',
        component: () => import( /* webpackChunkName: "exam" */ '../views/classCourse/exam/index.vue'),
      },
      {
        path: '/classCourse/wrongQuestions',
        name: 'wrongQuestions',
        component: () => import( /* webpackChunkName: "wrongQuestions" */ '../views/classCourse/wrongBank/index.vue'),
      },
      {
        path: '/classCourse/wrongQuestions/detail',
        name: 'wrongQuestionsDetail',
        component: () => import( /* webpackChunkName: "wrongQuestionsDetail" */ '../views/classCourse/wrongBank/detail.vue'),
      },
      {
        path: '/classCourse/evaluation',
        name: 'evaluation',
        component: () => import( /* webpackChunkName: "evaluation" */ '../views/classCourse/evaluation/index.vue'),
      },
      {
        path: '/classCourse/evaluation/knowledge',
        name: 'knowledge',
        component: () => import( /* webpackChunkName: "knowledge" */ '../views/classCourse/evaluation/knowledge/index.vue'),
      },
      {
        path: '/classCourse/evaluation/attitude',
        name: 'attitude',
        component: () => import( /* webpackChunkName: "attitude" */ '../views/classCourse/evaluation/attitude/index.vue'),
      },
      {
        path: '/classCourse/evaluation/skill',
        name: 'skill',
        component: () => import( /* webpackChunkName: "skill" */ '../views/classCourse/evaluation/skill/index.vue'),
      },
      {
        path: '/classCourse/evaluation/attainment',
        name: 'attainment',
        component: () => import( /* webpackChunkName: "attainment" */ '../views/classCourse/evaluation/attainment/index.vue'),
      },
      {
        path: '/classCourse/projectPractice',
        name: 'projectPractice',
        component: () => import( /* webpackChunkName: "projectPractice" */ '../views/classCourse/projectPractice'),
      },
      {
        path: '/classCourse/projectPractice/buildTeam',
        name: 'buildTeam',
        component: () => import( /* webpackChunkName: "buildTeam" */ '../views/classCourse/projectPractice/buildTeam'),
      },
      {
        path: '/classCourse/projectPractice/accountLocation',
        name: 'accountLocation',
        component: () => import( /* webpackChunkName: "accountLocation" */ '../views/classCourse/projectPractice/accountLocation'),
      },
      {
        path: '/classCourse/projectPractice/accountEstablish',
        name: 'accountEstablish',
        component: () => import( /* webpackChunkName: "accountEstablish" */ '../views/classCourse/projectPractice/accountEstablish'),
      },
      {
        path: '/classCourse/projectPractice/copywriting',
        name: 'copywriting',
        component: () => import( /* webpackChunkName: "copywriting" */ '../views/classCourse/projectPractice/copywriting'),
      },
      {
        path: '/classCourse/projectPractice/scenario',
        name: 'scenario',
        component: () => import( /* webpackChunkName: "scenario" */ '../views/classCourse/projectPractice/scenario'),
      },
      {
        path: '/classCourse/projectPractice/videoShooting',
        name: 'videoShooting',
        component: () => import( /* webpackChunkName: "videoShooting" */ '../views/classCourse/projectPractice/videoShooting'),
      },
      {
        path: '/classCourse/projectPractice/videoClip',
        name: 'videoClip',
        component: () => import( /* webpackChunkName: "videoClip" */ '../views/classCourse/projectPractice/videoClip'),
      },
      {
        path: '/classCourse/projectPractice/accountOperation',
        name: 'accountOperation',
        component: () => import( /* webpackChunkName: "accountOperation" */ '../views/classCourse/projectPractice/accountOperation'),
      },
      {
        path: '/classCourse/projectPractice/roadshow',
        name: 'roadshow',
        component: () => import( /* webpackChunkName: "roadshow" */ '../views/classCourse/projectPractice/roadshow'),
      },
      {
        path: '/classCourse/projectPractice/analysis',
        name: 'analysis',
        component: () => import( /* webpackChunkName: "analysis" */ '../views/classCourse/projectPractice/analysis'),
      },
    ]
  },
  {
    path: '/assistantMode',
    name: 'assistantMode',
    redirect: '/assistantMode/chapters',
    component: () => import( /* webpackChunkName: "assistantMode" */ '../views/assistantMode/index.vue'),
    children: [
      {
        path: '/assistantMode/chapters',
        name: 'aChapters',
        component: () => import( /* webpackChunkName: "aChapters" */ '../views/assistantMode/chapters.vue'),
      },
      {
        path: '/assistantMode/works',
        name: 'aWorks',
        component: () => import( /* webpackChunkName: "aWorks" */ '../views/assistantMode/works.vue'),
      },
      {
        path: '/assistantMode/works',
        name: 'aWorks',
        component: () => import( /* webpackChunkName: "aWorks" */ '../views/assistantMode/works.vue'),
      },
      {
        path: '/assistantMode/questionBank',
        name: 'questionBank',
        component: () => import( /* webpackChunkName: "questionBank" */ '../views/assistantMode/questionBank/index.vue'),
      },
      {
        path: '/assistantMode/questionBank/detail',
        name: 'questionDetail',
        component: () => import( /* webpackChunkName: "questionDetail" */ '../views/assistantMode/questionBank/detail.vue'),
      },
      // {
      //   path: '/assistantMode/exam',
      //   name: 'exam',
      //   component: () => import( /* webpackChunkName: "exam" */ '../views/assistantMode/exam/index.vue'),
      // },
    ]
  },
  {
    path: '/securityQuestion',
    name: 'securityQuestion',
    component: () => import( /* webpackChunkName: "securityQuestion" */ '../views/securityQuestion/index.vue'),
  },
  {
    path: '/helpCenter',
    name: 'helpCenter',
    component: () => import( /* webpackChunkName: "helpCenter" */ '../views/helpCenter/index.vue'),
  },
  {
    path: '/message',
    name: 'message',
    component: () => import( /* webpackChunkName: "message" */ '../views/message/index.vue'),
  }]
},
{
  path: '/courseDetail',
  name: 'courseDetail',
  redirect: '/courseDetail/video',
  component: () => import( /* webpackChunkName: "courseDetail" */ '../views/courseDetail/index.vue'),
  children: [
    {
      path: '/courseDetail/video',
      name: 'video',
      component: () => import( /* webpackChunkName: "video" */ '../views/courseDetail/video.vue'),
    },
    {
      path: '/courseDetail/courseware',
      name: 'courseware',
      component: () => import( /* webpackChunkName: "courseware" */ '../views/courseDetail/courseware.vue'),
    },
    {
      path: '/courseDetail/testing',
      name: 'testing',
      component: () => import( /* webpackChunkName: "testing" */ '../views/courseDetail/testing.vue'),
    },
    {
      path: '/courseDetail/testing/reviewTest',
      name: 'reviewTest',
      component: () => import( /* webpackChunkName: "reviewTest" */ '../views/courseDetail/reviewTest.vue'),
    },
    {
      path: '/courseDetail/data',
      name: 'data',
      component: () => import( /* webpackChunkName: "data" */ '../views/courseDetail/data.vue'),
    },
    {
      path: '/courseDetail/practice',
      name: 'practice',
      component: () => import( /* webpackChunkName: "practice" */ '../views/courseDetail/practice/index.vue'),
    },
    {
      path: '/courseDetail/practice/pdf',
      name: 'practicePdf',
      component: () => import( /* webpackChunkName: "practicePdf" */ '../views/courseDetail/practice/pdfDetail.vue'),
    },
    {
      path: '/courseDetail/practice/detail',
      name: 'practiceDetail',
      component: () => import( /* webpackChunkName: "practiceDetail" */ '../views/courseDetail/practice/detail.vue'),
    },
    {
      path: '/courseDetail/practice/uploadWorks',
      name: 'uploadWorks',
      component: () => import( /* webpackChunkName: "uploadWorks" */ '../views/courseDetail/practice/uploadWorks.vue'),
    },
    {
      path: '/courseDetail/statistics',
      name: 'statistics',
      component: () => import( /* webpackChunkName: "statistics" */ '../views/courseDetail/statistics.vue'),
    },
    {
      path: '/courseDetail/activity',
      name: 'activity',
      component: () => import( /* webpackChunkName: "activity" */ '../views/courseDetail/activity/index.vue'),
    },
    {
      path: '/courseDetail/activity/sign',
      name: 'sign',
      component: () => import( /* webpackChunkName: "sign" */ '../views/courseDetail/activity/signin.vue'),
    },
    {
      path: '/courseDetail/activity/vote',
      name: 'vote',
      component: () => import( /* webpackChunkName: "vote" */ '../views/courseDetail/activity/vote.vue'),
    },
    {
      path: '/courseDetail/activity/pick',
      name: 'pick',
      component: () => import( /* webpackChunkName: "pick" */ '../views/courseDetail/activity/select.vue'),
    },
    {
      path: '/courseDetail/activity/answer',
      name: 'answer',
      component: () => import( /* webpackChunkName: "answer" */ '../views/courseDetail/activity/question.vue'),
    },
    {
      path: '/courseDetail/activity/discuss',
      name: 'discuss',
      component: () => import( /* webpackChunkName: "discuss" */ '../views/courseDetail/activity/discuss.vue'),
    },
    {
      path: '/courseDetail/activity/quiz',
      name: 'quiz',
      component: () => import( /* webpackChunkName: "quiz" */ '../views/courseDetail/activity/quiz.vue'),
    },
    {
      path: '/courseDetail/works',
      name: 'works',
      component: () => import( /* webpackChunkName: "works" */ '../views/courseDetail/works.vue'),
    },
    {
      path: '/courseDetail/works/uploadWorks',
      name: 'uploadWorks',
      component: () => import( /* webpackChunkName: "uploadWorks" */ '../views/classCourse/uploadWorks.vue'),
    },
    {
      path: '/courseDetail/python',
      name: 'python',
      component: () => import( /* webpackChunkName: "python" */ '../views/courseDetail/python.vue'),
    }
  ]
},
{
  path: '/assistantMode/courseDetail',
  name: 'aCourseDetail',
  redirect: '/assistantMode/courseDetail/data',
  component: () => import( /* webpackChunkName: "courseDetail" */ '../views/assistantMode/courseDetail/index.vue'),
  children: [
    {
      path: '/assistantMode/courseDetail/data',
      name: 'aData',
      component: () => import( /* webpackChunkName: "aData" */ '../views/assistantMode/courseDetail/data.vue'),
    },
    {
      path: '/assistantMode/courseDetail/practice',
      name: 'aPractice',
      component: () => import( /* webpackChunkName: "aPractice" */ '../views/assistantMode/courseDetail/practice/index.vue'),
    },
    {
      path: '/assistantMode/courseDetail/practice/practiceBank',
      name: 'practiceBank',
      component: () => import( /* webpackChunkName: "practiceBank" */ '../views/assistantMode/courseDetail/practice/practiceBank.vue'),
    },
    {
      path: '/assistantMode/courseDetail/practice/pdf',
      name: 'aPracticePdf',
      component: () => import( /* webpackChunkName: "aPracticePdf" */ '../views/assistantMode/courseDetail/practice/pdfDetail.vue'),
    },
    {
      path: '/assistantMode/courseDetail/practice/detail',
      name: 'aPracticeDetail',
      component: () => import( /* webpackChunkName: "aPracticeDetail" */ '../views/assistantMode/courseDetail/practice/detail.vue'),
    },
    {
      path: '/assistantMode/courseDetail/works',
      name: 'aWorks',
      component: () => import( /* webpackChunkName: "aWorks" */ '../views/assistantMode/courseDetail/works.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity',
      name: 'aActivity',
      component: () => import( /* webpackChunkName: "activity" */ '../views/assistantMode/courseDetail/activity/index.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/sign',
      name: 'aSign',
      component: () => import( /* webpackChunkName: "aSign" */ '../views/assistantMode/courseDetail/activity/signin/index.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/sign/detail',
      name: 'aSignDetail',
      component: () => import( /* webpackChunkName: "aSignDetail" */ '../views/assistantMode/courseDetail/activity/signin/detail.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/vote',
      name: 'aVote',
      component: () => import( /* webpackChunkName: "aVote" */ '../views/assistantMode/courseDetail/activity/vote/index.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/vote/detail',
      name: 'aVoteDetail',
      component: () => import( /* webpackChunkName: "aVoteDetail" */ '../views/assistantMode/courseDetail/activity/vote/detail.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/pick',
      name: 'aPick',
      component: () => import( /* webpackChunkName: "aPick" */ '../views/assistantMode/courseDetail/activity/select/index.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/pick/detail',
      name: 'aPickDetail',
      component: () => import( /* webpackChunkName: "aPickDetail" */ '../views/assistantMode/courseDetail/activity/select/detail.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/answer',
      name: 'aAnswer',
      component: () => import( /* webpackChunkName: "aAnswer" */ '../views/assistantMode/courseDetail/activity/question/index.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/answer/detail',
      name: 'aAnswerDetail',
      component: () => import( /* webpackChunkName: "aAnswerDetail" */ '../views/assistantMode/courseDetail/activity/question/detail.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/discuss',
      name: 'aDiscuss',
      component: () => import( /* webpackChunkName: "aDiscuss" */ '../views/assistantMode/courseDetail/activity/discuss/index.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/discuss/detail',
      name: 'aDiscussDetail',
      component: () => import( /* webpackChunkName: "aDiscussDetail" */ '../views/assistantMode/courseDetail/activity/discuss/detail.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/quiz',
      name: 'aQuiz',
      component: () => import( /* webpackChunkName: "aQuiz" */ '../views/assistantMode/courseDetail/activity/quiz/index.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/quiz/detail',
      name: 'aQuizDetail',
      component: () => import( /* webpackChunkName: "aQuizDetail" */ '../views/assistantMode/courseDetail/activity/quiz/detail.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/score',
      name: 'aScore',
      component: () => import( /* webpackChunkName: "aScore" */ '../views/assistantMode/courseDetail/activity/score/index.vue'),
    },
    {
      path: '/assistantMode/courseDetail/activity/score/detail',
      name: 'aScoreDetail',
      component: () => import( /* webpackChunkName: "aScoreDetail" */ '../views/assistantMode/courseDetail/activity/score/detail.vue'),
    },
    {
      path: '/assistantMode/courseDetail/appraise',
      name: 'aAppraise',
      component: () => import( /* webpackChunkName: "aAppraise" */ '../views/assistantMode/courseDetail/appraise/index.vue'),
    },
    {
      path: '/assistantMode/courseDetail/appraise/detail',
      name: 'aAppraiseDetail',
      component: () => import( /* webpackChunkName: "aAppraiseDetail" */ '../views/assistantMode/courseDetail/appraise/detail.vue'),
    },
  ]
},
{
  path: '/classCourse/exam/detail',
  name: 'examDetail',
  component: () => import( /* webpackChunkName: "examDetail" */ '../views/classCourse/exam/detail.vue'),
},
{
  path: '/classCourse/exam/makeExam',
  name: 'makeExam',
  component: () => import( /* webpackChunkName: "makeExam" */ '../views/classCourse/exam/makeExam.vue'),
},
{
  path: '/simulation',
  name: 'simulation',
  redirect: '/simulation/doudian/login',
  component: () => import( /* webpackChunkName: "simulation" */ '../views/simulation/index.vue'),
  children: [
    {
      path: '/simulation/doudian/login',
      name: 'doudianLogin',
      component: () => import( /* webpackChunkName: "doudianLogin" */ '../views/simulation/doudian/login.vue'),
    },
    {
      path: '/simulation/doudian',
      name: 'doudian',
      component: () => import( /* webpackChunkName: "doudian" */ '../views/simulation/doudian/index.vue'),
    },
    {
      path: '/simulation/doudian/step',
      name: 'step',
      component: () => import( /* webpackChunkName: "step" */ '../views/simulation/doudian/step.vue'),
    },
    {
      path: '/simulation/doudian/step/stepThree',
      name: 'stepThree',
      component: () => import( /* webpackChunkName: "stepThree" */ '../views/simulation/doudian/stepThree.vue'),
    },
    {
      path: '/simulation/doudian/step/stepFour',
      name: 'stepFour',
      component: () => import( /* webpackChunkName: "stepFour" */ '../views/simulation/doudian/stepFour.vue'),
    },
    {
      path: '/simulation/phone',
      name: 'phone',
      component: () => import( /* webpackChunkName: "phone" */ '../views/simulation/phone/index.vue'),
    },
    {
      path: '/simulation/douplus',
      name: 'douplus',
      component: () => import( /* webpackChunkName: "douplus" */ '../views/simulation/phone/douplus/index.vue'),
    },
    {
      path: '/simulation/qianchuan',
      name: 'qianchuan',
      component: () => import( /* webpackChunkName: "qianchuan" */ '../views/simulation/qianchuan/index.vue'),
    },
    {
      path: '/simulation/qianchuan/videoLite',
      name: 'videoLite',
      component: () => import( /* webpackChunkName: "videoLite" */ '../views/simulation/qianchuan/videoLite/index.vue'),
    },
    {
      path: '/simulation/qianchuan/liveLite',
      name: 'liveLite',
      component: () => import( /* webpackChunkName: "liveLite" */ '../views/simulation/qianchuan/liveLite/index.vue'),
    },
    {
      path: '/simulation/qianchuan/searchVideoStandard',
      name: 'searchVideoStandard',
      component: () => import( /* webpackChunkName: "searchVideoStandard" */ '../views/simulation/qianchuan/searchVideoStandard/index.vue'),
    },
    {
      path: '/simulation/qianchuan/searchLiveStandard',
      name: 'searchLiveStandard',
      component: () => import( /* webpackChunkName: "searchLiveStandard" */ '../views/simulation/qianchuan/searchLiveStandard/index.vue'),
    },
    {
      path: '/simulation/qianchuan/createVideoStandard',
      name: 'createVideoStandard',
      component: () => import( /* webpackChunkName: "createVideoStandard" */ '../views/simulation/qianchuan/createVideoStandard/index.vue'),
    },
    {
      path: '/simulation/qianchuan/createLiveStandard',
      name: 'createLiveStandard',
      component: () => import( /* webpackChunkName: "createLiveStandard" */ '../views/simulation/qianchuan/createLiveStandard/index.vue'),
    },
    {
      path: '/simulation/douyin/register/index',
      name: 'douyinRegister',
      component: () => import( /* webpackChunkName: "douplus" */ '../views/simulation/phone/douyinRegister'),
    },
    {
      path: '/simulation/douyin/register/info',
      name: 'douyinRegisterInfo',
      component: () => import( /* webpackChunkName: "douplus" */ '../views/simulation/phone/douyinRegister/info'),
    },
    {
      path: '/simulation/douyin/register/me',
      name: 'douyinRegisterMe',
      component: () => import( /* webpackChunkName: "douplus" */ '../views/simulation/phone/douyinRegister/me'),
    },
    {
      path: '/simulation/buyin',
      name: 'buyin',
      component: () => import( /* webpackChunkName: "buyin" */ '../views/simulation/juliangbaiying/'),
      children: [{
        path: 'live',
        name: 'buyinLive',
        component: () => import( /* webpackChunkName: "buyin" */ '../views/simulation/juliangbaiying/live'),
        children: [{
          path: 'provide',
          name: 'provide',
          component: () => import( /* webpackChunkName: "buyin" */ '../views/simulation/juliangbaiying/live/provide'),
        }, {
          path: 'goods',
          name: 'liveGoods',
          component: () => import( /* webpackChunkName: "buyin" */ '../views/simulation/juliangbaiying/live/goods'),
        }, {
          path: '*',
          component: () => import( /* webpackChunkName: "buyin" */ '../views/simulation/juliangbaiying/live/blank'),
        }]
      }]
    },
    {
      path: '/simulation/blessingBag',
      name: 'blessingBag',
      component: () => import( /* webpackChunkName: "blessingBag" */ '../views/simulation/phone/blessingBag'),
    },
    {
      path: '/simulation/douyinchuchuang',
      name: 'douyinchuchuang',
      component: () => import( /* webpackChunkName: "douyinchuchuang" */ '../views/simulation/phone/douyinchuchuang/'),
      children: [{
        path: 'index',
        name: 'home',
        component: () => import( /* webpackChunkName: "home" */ '../views/simulation/phone/douyinchuchuang/home'),
      },{
        path: 'step1',
        name: 'step1',
        component: () => import( /* webpackChunkName: "step1" */ '../views/simulation/phone/douyinchuchuang/step1'),
      },{
        path: 'authentication',
        name: 'authentication',
        component: () => import( /* webpackChunkName: "authentication" */ '../views/simulation/phone/douyinchuchuang/step1/authentication'),
      },{
        path: 'step2',
        name: 'step2',
        component: () => import( /* webpackChunkName: "step2" */ '../views/simulation/phone/douyinchuchuang/step2'),
      },{
        path: 'qualificationType',
        name: 'qualificationType',
        component: () => import( /* webpackChunkName: "qualificationType" */ '../views/simulation/phone/douyinchuchuang/step2/qualificationType'),
      },{
        path: 'qualificationBinding',
        name: 'qualificationBinding',
        component: () => import( /* webpackChunkName: "qualificationBinding" */ '../views/simulation/phone/douyinchuchuang/step2/qualificationBinding'),
      },{
        path: 'confirmPage',
        name: 'confirmPage',
        component: () => import( /* webpackChunkName: "confirmPage" */ '../views/simulation/phone/douyinchuchuang/step2/confirmPage'),
      },{
        path: 'certification',
        name: 'certification',
        component: () => import( /* webpackChunkName: "certification" */ '../views/simulation/phone/douyinchuchuang/step2/certification'),
      },{
        path: 'success',
        name: 'success',
        component: () => import( /* webpackChunkName: "success" */ '../views/simulation/phone/douyinchuchuang/step2/success'),
      },{
        path: 'payAccount',
        name: 'payAccount',
        component: () => import( /* webpackChunkName: "payAccount" */ '../views/simulation/phone/douyinchuchuang/step2/payAccount'),
      },{
        path: 'fillAccount',
        name: 'fillAccount',
        component: () => import( /* webpackChunkName: "fillAccount" */ '../views/simulation/phone/douyinchuchuang/step2/fillAccount'),
      }]
    },
  ]
},
{
  path: '/login',
  name: 'login',
  component: () => import( /* webpackChunkName: "login" */ '../views/login/index.vue'),
},
{
  path: '/register',
  name: 'register',
  component: () => import( /* webpackChunkName: "register" */ '../views/register/index.vue'),
}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router